var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 22C7.95386 22.0024 4.3048 19.5659 2.75597 15.8276C1.20714 12.0893 2.06384 7.78606 4.9263 4.92598C7.4536 2.39868 11.1372 1.41166 14.5896 2.33672C18.0419 3.26177 20.7385 5.95836 21.6636 9.41072C22.5886 12.8631 21.6016 16.5467 19.0743 19.074C17.2018 20.955 14.6545 22.0086 12.0003 22ZM4.0003 12.172C4.04762 16.5732 7.64141 20.1095 12.0428 20.086C16.4443 20.0622 19.9998 16.4875 19.9998 12.086C19.9998 7.68449 16.4443 4.10975 12.0428 4.08598C7.64141 4.06244 4.04762 7.59874 4.0003 12V12.172ZM9.4093 16L8.0003 14.59L10.5903 12L8.0003 9.40998L9.4103 7.99998L12.0003 10.59L14.5903 7.99998L16.0003 9.40998L13.4103 12L16.0003 14.59L14.5913 16L12.0003 13.41L9.4103 16H9.4093Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4550452471c373161eb440d90c3aecf2.svg";
export { ForwardRef as ReactComponent };